import React from 'react';
import {Box, Stack, Typography} from '@mui/material';

const ExerciceVideos = ({exerciceVideos, name}) => {

    if(!exerciceVideos.length) return 'Loading...';

  return (
    <Box sx={{marginTop:{lg:'100px', xs:'20px'}}} p="20px" >
        <Typography variant="h3" mb="33px">
        regarder les vidéos d'exercices <span style={{color:'#ff2625', textTransform:'capitalize'}} >{name}</span>
        </Typography>
        <Stack justifyContent='flex-start' flexWrap={'wrap'} alignItems="center"
            sx={{
                flexDirection:{lg:'row'},
                gap:{lg:'50px', xs:'0'}
            }}
        >
            {exerciceVideos?.slice(0,6).map((item, index) => (
                <a 
                    key={index}
                    className="exercise-video"
                    href={`https://www.youtube.com/watch?v=${item.video.videoId}`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <img src={item.video.thumbnails[0].url} alt={item.video.title} />
                    <Box>
                        <Typography variant="h5" color="#000">
                            {item.video.title}
                        </Typography>
                        <Typography variant="h6" color="#000">
                            {item.video.channelName}
                        </Typography>
                    </Box>
                </a>
            ))}
        </Stack>
    </Box>
  )
}

export default ExerciceVideos